import { Component, OnInit, ViewChild } from '@angular/core';
import { ReqResService } from '../../service/req-res.service';
import * as moment from 'moment';
import { PluginService } from '../../service/plugin.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../service/auth/auth.service';
import { ConfirmationdialogService } from '../../service/confirmationdialog.service';
import { Title } from '@angular/platform-browser';
declare var $: any;
declare var window: any;
declare var toastr: any;
declare var renderCalendar: any;

@Component({
  selector: 'app-leadcalendar',
  templateUrl: './leadcalendar.component.html',
  styleUrls: ['./leadcalendar.component.css']
})
export class LeadcalendarComponent implements OnInit {
  //@ViewChild('focusInput') searchElement;
  loading: boolean = true;
  calendarUpd: any = {};

  calendarView: string = 'dayGridWeek';
  calendarDate: string = moment(new Date()).format('YYYY-MM-DD')
  calendarSelectedDate: any = new Date();
  calendarSelectedTime: string = '';
  calendarSelectedDurationDay: number = 0;
  calendarSelectedDurationHour: number = 0;
  calendarSelectedDurationMinute: number = 0;
  calendarEventData: any = {};
  calendarData: any = [];
  modalType: string = '';
  checkedOpe: boolean = false;
  //del variables
  delId: number;
  delType: string;
  delCount: number;
  delBulkArray: any = [];
  delType2: string;


  constructor(private router: Router, private reqRes: ReqResService, private authService: AuthService, private pluginservice: PluginService, private confirmationDialogService: ConfirmationdialogService, private titleService: Title) {
    this.titleService.setTitle('Calendar');
  }

  ngOnInit(): void {
    $('.modal-dialog').draggable({
      "handle": ".modal-header,.modal-footer"
    });
    $('.modal').on('hidden.bs.modal', function () {
      $('.modal-dialog').attr('style', 'inset: unset')
    });
    let $this = this;
    $('#activty').select2();
    $('#activty').on("select2:selecting", function (e) {
      $this.activityObj.activityTypeId = parseInt(e.params.args.data.id);
      $this.activityTypeChange($this.activityObj.activityTypeId);
    });



    this.loading = false;
    setTimeout(() => {
      this.getFilterModalData_('Calendar');
    }, 100);
    localStorage.removeItem("FilterCalendarProperties");
    this.localstorageVal = (localStorage.getItem('FilterCalendarProperties')) ? localStorage.getItem('FilterCalendarProperties') : '';
  }

  ngAfterViewChecked() {
    $("#dropDownAssigner").click(() => {
      this.searchActAssigner = '';
    });

    $("#dropDownAssignerFilter").click(() => {
      this.searchFilterAssigner = '';
    });
  }

  getCalendarData() {
    let filter = ' ';
    let filteredProperties_ = localStorage.getItem('FilterCalendarProperties');
    filter = (this.projectFilteredBgOpe == 0) ? (filteredProperties_) ? filteredProperties_ : ' ' : this.filteredProperties;
    let _obj: any = {};
    _obj.id = 0;
    _obj.filter = filter;
    this.reqRes.postData('/Lead/GetLeadCalendarData', _obj).subscribe(data => {
      this.calendarData = data;
      this.loading = false;
        this.setCalendar(this.calendarData);
    },
      error => {
        toastr.error("​Oops! Something went wrong", '', { timeOut: 1000 });
        console.log(error);
      })
  }

  getCalendarEventData(id) {
    this.reqRes.getData('/Lead/GetLeadCalendarEvent/' + id).subscribe(data => {
      this.calendarEventData = data;

      window.dispatchEvent(new Event('resize'));
      $('#eventDetails').modal('show');
    },
      error => {
        toastr.error("​Oops! Something went wrong", '', { timeOut: 1000 });
        console.log(error)
      })
  }
  goToMap(address: string) {
    window.open('https://maps.google.com?q=' + address, '_blank');
  }
  setCalendar(events): void {
    var eventArray = events;
    var updateTitle = function updateTitle(title) {
      return $('.calendar-title').text(title);
    };
    var calendarEl = document.getElementById('appCalendar');
    if (calendarEl) {
      var $this = this;
      var calendar = renderCalendar(calendarEl, {
        header: {
          left: 'prev',
          center: 'title',
          right: 'next'
        },
        headerToolbar: false,
        height: 800,
        editable:false,
        initialView: $this.calendarView,
        initialDate: $this.calendarDate,
        stickyHeaderDates: true,
        views: {
          month: {
            dayMaxEvents: 2
          },
          week: {
            dayMaxEvents: 20
          },
        },
        businessHours: {
          daysOfWeek: [1, 2, 3, 4, 5, 6],
          startTime: '08:00',
          endTime: '20:00',
        },
        nowIndicator: true,
        events: eventArray,
        slotMinTime: '08:00',
        slotMaxTime: '20:00',
        selectable: false,
        eventDisplay: 'block',
        selectMirror: true,
        eventContent: function (arg, createElement) {
          $this.calendarView = arg.view.type;
          $('span').remove('.fc-list-event-dot')
          $('div').remove('.fc-daygrid-event-dot');

          let arrayOfDomNodes = []
          function createElementFromHTML(htmlString) {
            var div = document.createElement('div');
            div.innerHTML = htmlString.trim();
            return div.firstChild;
          }
          let user_img = `<img  style="margin-top: 5px;width: 28px;height: 28px;" data-toggle="tooltip" data-placement="top" class="rounded-circle" src="` + arg.event.extendedProps.assigneeImg + `" alt="` + arg.event.extendedProps.assigneeName + `" title="` + arg.event.extendedProps.assigneeName + `" data-original-title="` + arg.event.extendedProps.assigneeName + `">`
          let user_icon = "";
          if (arg.event.extendedProps.assigneeImgOpe == 0) {
            user_icon = `<span class="circle-user-icon calendar-user-icon" data-toggle="tooltip" data-placement="top" title="` + arg.event.extendedProps.assigneeName + `" data-original-title="` + arg.event.extendedProps.assigneeName + `"><i class="fas fa-user"></i></span>`;
          }
         else if (arg.event.extendedProps.assigneeImgOpe == 1) {

            user_icon = `<span class="circle-user-icon calendar-group-icon" data-toggle="tooltip" data-placement="top" title="` + arg.event.extendedProps.assigneeName + `" data-original-title="` + arg.event.extendedProps.assigneeName + `"><i class="fas fa-user-friends"></i></span>`
          }
          else if (arg.event.extendedProps.assigneeImgOpe == 2) {

            user_icon = `<span class="circle-user-icon calendar-group-icon" style="padding-left:8px;padding-right:8px"; data-toggle="tooltip" data-placement="top" title="` + arg.event.extendedProps.assigneeName + `" data-original-title="` + arg.event.extendedProps.assigneeName + `"><i class="fas fa-briefcase"></i></span>`
          }
          let eventMainSTR = `
<div style="display:flex;justify-content:left">
<div class="avatar avatar-sm remove-asg mr-2">
`+ (arg.event.extendedProps.assigneeImg?.length > 0 ? user_img : user_icon) + `
</div>
<div>
<span>`+ arg.event._def.title + `</span>
<span style="font-size: 11px !important;font-weight: 400;color: #000 !important;display: flex;">`+ arg.event.extendedProps.leadName + `</span>
</div>
</div>`
          let eventMainSTRWD = '';
          if ($this.calendarView == 'dayGridWeek') {
            eventMainSTRWD = `
<span>`+ arg.event.extendedProps.projectName + ' ' + arg.event._def.title + `</span>
</div>
</div>`
          }
          else {
            eventMainSTRWD = `
<span>` + arg.event._def.title + `</span>
</div>
</div>`
          }
          let eventMain;

          if ($this.calendarView == 'dayGridMonth' || $this.calendarView == 'dayGridWeek') {
            eventMain = createElementFromHTML(eventMainSTRWD);
          }
          else {
            eventMain = createElementFromHTML(eventMainSTR);
          }
          setTimeout(function () { $('.fc-event-main').addClass('fc-event-title') })
          if ($this.calendarView == 'listWeek') {
            $("#cal" + arg.event._def.publicId + " .fc-list-event-time").html('');
            setTimeout(function () {
              $("#cal" + arg.event._def.publicId + " .fc-list-event-time").html(moment(arg.event.start).format('HH:mm A'));
              $(".fc-list-event-dot").remove();
            })
          }
         
            arrayOfDomNodes = [eventMain]
          return { domNodes: arrayOfDomNodes }
        },
        eventDidMount: function (info) {
          if (info.view.type == 'listWeek') {
            info.el.id = "cal" + info.event.id;
            info.el.getElementsByClassName("fc-list-event-time")[0].innerHTML = moment(info.event.start).format('HH:mm A');
          }
          if (info.view.type == 'timeGridDay') {
            document.querySelectorAll(".fc-event-resizer").forEach(el => el.remove());
          }
        },
        eventDataTransform: function (eventData) {
          var dur = (new Date(eventData?.end)).getTime() - (new Date(eventData?.start)).getTime(); //total event duration
          if (dur >= 86400000 || eventData?.end == null) {
            eventData.allDay = true;
          }
          return (eventData);
        },
        eventTimeFormat: {
          hour: 'numeric',
          minute: '2-digit',
          omitZeroMinute: true,
          meridiem: true
        },
        datesSet: function (e) {
          setTimeout(function () {
            $('div').remove('.fc-event-time');
            $('div').remove('.fc-daygrid-event-dot');
            $('span').remove('.fc-list-event-dot')
          })
        },
        eventClick: function eventClick(info) {
          //$this.newActivityOpe = 0;
          $this.getCalendarEventData(info.event.id);
          window.dispatchEvent(new Event('resize'));
        },
        eventResize: function (info) {
          //if (confirm("Do you confirm these changes?")) {
          //  $this.calendarUpd.id = parseInt(info.event.id);
          //  var start = new Date(info.event.start);
          //  var end = new Date(info.event.end);
          //  $this.calendarUpd.begdate = moment(start, "M/DD/YYYY hh:mm:ss A").format("MM/DD/YYYY HH:mm:ss")
          //  $this.calendarUpd.enddate = moment(end, "M/DD/YYYY hh:mm:ss A").format("MM/DD/YYYY HH:mm:ss")
          //  $this.calendarUpd.ope = 'lead';
          //  $this.reqRes.postData('/Global/CalendarDateUpd', $this.calendarUpd).subscribe(data => {
          //    let index = eventArray.findIndex(item => item.id == JSON.parse(data)[0].id)
          //    eventArray.splice(index, 1);
          //    eventArray.push(JSON.parse(data)[0])
          //    $this.setCalendar(eventArray)
          //    toastr.success('Done!', '', { timeOut: 1000 });
          //  }, error => {  toastr.error("​Oops! Something went wrong",'', { timeOut: 1000 });console.log(error) })
          //}
          //else {
          //  info.revert();
          //}
        },
        eventDrop: function (info, dayDelta, minuteDelta, allDay, revertFunc) {
          var start = new Date(info.event.start);
          var end = new Date(info.event.end);
          $this.calendarUpd.id = parseInt(info.event.id);
          $this.calendarUpd.begdate = moment(start, "M/DD/YYYY hh:mm:ss A").format("MM/DD/YYYY HH:mm:ss");
          $this.calendarUpd.enddate = moment(end, "M/DD/YYYY hh:mm:ss A").format("M/DD/YYYY HH:mm:ss");
          $this.calendarUpd.ope = 'lead';
          $this.reqRes.getData('/Lead/GetLeadCalendarEvent/' + info.event.id).subscribe(data => {
            $this.calendarEventData = data;
            var ids = (data.assigner.map((item) => item.id).toString()) ? data.assigner.map((item) => item.id).toString() : 0;
                  $this.checkEvent = false;
                if ($this.calendarEventData.statusId == 2) {
                  $this.checkEvent = false;
                }
                if (confirm("Do you confirm these changes?")) {
                  if (calendar.currentData.currentViewType == 'dayGridMonth' || calendar.currentData.currentViewType == 'dayGridWeek') {
                    if ($this.checkEvent) {
                      $this.confirmationDialogService.confirm('Warning', 'Time of the activity coincides with the time of the following activities. Do you want to continue?', $this.crossData)
                        .then((confirmed) => {
                          if (confirmed) {
                            $this.reqRes.postData('/Global/CalendarDateUpd', $this.calendarUpd).subscribe(data => {
                              let index = eventArray.findIndex(item => item.id == JSON.parse(data)[0].id)
                              eventArray.splice(index, 1);
                              eventArray.push(JSON.parse(data)[0])
                              $this.setCalendar(eventArray)
                              toastr.success('Done!', '', { timeOut: 1000 });
                            }, error => {
                              toastr.error("​Oops! Something went wrong", '', { timeOut: 1000 });
                              console.log(error)
                            })

                          } else {
                            info.revert();
                          }
                        })
                        .catch(() => {
                        })
                    }
                    else {
                      $this.reqRes.postData('/Global/CalendarDateUpd', $this.calendarUpd).subscribe(data => {
                        let index = eventArray.findIndex(item => item.id == JSON.parse(data)[0].id)
                        eventArray.splice(index, 1);
                        eventArray.push(JSON.parse(data)[0])
                        $this.setCalendar(eventArray)
                        toastr.success('Done!', '', { timeOut: 1000 });
                      }, error => {
                        toastr.error("​Oops! Something went wrong", '', { timeOut: 1000 });
                        console.log(error)
                      })
                    }
                  }
                  else {
                    $this.reqRes.postData('/Global/CalendarDateUpd', $this.calendarUpd).subscribe(data => {
                      let index = eventArray.findIndex(item => item.id == JSON.parse(data)[0].id)
                      eventArray.splice(index, 1);
                      eventArray.push(JSON.parse(data)[0])
                      $this.setCalendar(eventArray)
                      toastr.success('Done!', '', { timeOut: 1000 });
                    }, error => {
                      toastr.error("​Oops! Something went wrong", '', { timeOut: 1000 });
                      console.log(error)
                    })
                  }
                }
                else {
                  info.revert();
                }


                if (calendar.currentData.currentViewType == 'dayGridMonth' || calendar.currentData.currentViewType == 'dayGridWeek') {
                  $('div').remove('.fc-event-time')
                  $('div').remove('.fc-daygrid-event-dot')
                }
                else if (calendar.currentData.currentViewType == 'listWeek') {
                  $('div').remove('.fc-list-event-dot')
                  $('span').remove('.fc-list-event-dot')
                }
          },
            error => {
              toastr.error("​Oops! Something went wrong", '', { timeOut: 1000 });
              console.log(error)
            })
        },
        select: function (date) {
          var start = new Date(date.start);
          var end = new Date(date.end);
          const diffTime = Math.abs(end.getTime() - start.getTime());
          const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
          const diffHour = Math.floor(diffTime / (1000 * 60 * 60)) % 24;
          const diffMinute = Math.round(((diffTime % 86400000) % 3600000) / 60000);
          let startDate = start.toLocaleString('en-GB').split(", ")[0];
          let startTime;
          if (calendar.currentData.currentViewType == 'timeGridDay') {
            startTime = moment(start).format('hh:mm A');
          }
          else {
            startTime = moment(new Date()).format('hh:mm A');
          }
          $this.calendarSelectedDate = start;
          $this.calendarSelectedTime = startTime;
          $this.calendarSelectedDurationDay = diffDays;
          $this.calendarSelectedDurationHour = diffHour;
          $this.calendarSelectedDurationMinute = diffMinute;
          /*$this.newLeadSearch();*/
        },
      });
      if (calendar.currentData.currentViewType == 'dayGridMonth') {

        $('div').remove('.fc-event-time')
        $('div').remove('.fc-daygrid-event-dot')
      }
      updateTitle(calendar.currentData.viewTitle);
      $(document).on('click', '[data-event]', function (_ref) {
        var currentTarget = _ref.currentTarget;
        var type = $(currentTarget).data('event');
        var calendarGetDate = new Date(calendar.getDate().setMonth(calendar.getDate().getMonth() + 1));
        $this.calendarDate = moment(calendarGetDate).format('YYYY-MM-DD');

        switch (type) {
          case 'prev':
            calendar.prev();
            $this.calendarDate = moment(calendar.currentData.currentDate).format('YYYY-MM-DD');
            updateTitle(calendar.currentData.viewTitle);
            $('.fc-list-table .fc-list-day th').addClass("z-index1000");
            break;
          case 'next':
            calendar.next();
            $this.calendarDate = moment(calendar.currentData.currentDate).format('YYYY-MM-DD');
            updateTitle(calendar.currentData.viewTitle);
            $('.fc-list-table .fc-list-day th').addClass("z-index1000");
            break;
          case 'today':
            $this.calendarDate = moment(new Date()).format('YYYY-MM-DD');
            calendar.today();
            updateTitle(calendar.currentData.viewTitle);
            $('.fc-list-table .fc-list-day th').addClass("z-index1000");
            break;
          default:
            calendar.today();
            break;
        }
      });
      $(document).on('click', '[data-fc-view]', function (e) {
        e.preventDefault();
        var el = $(e.currentTarget);
        var text = el.text();
        el.parent().find('.active').removeClass('active');
        el.addClass('active');
        $('[data-view-title]').text(text);
        setTimeout(function () { $('[data-toggle="tooltip"]').tooltip(); }, 100)
        calendar.changeView(el.data('fc-view'));
        $this.calendarView = calendar.currentData.currentViewType;
        if (calendar.currentData.currentViewType == 'dayGridMonth' || calendar.currentData.currentViewType == 'dayGridWeek') {
          $('div').remove('.fc-event-time')
          $('div').remove('.fc-daygrid-event-dot')
        }
        else if (calendar.currentData.currentViewType == 'listWeek') {
          $('div').remove('.fc-list-event-dot');
          $('.fc-list-table .fc-list-day th').addClass("z-index1000");
        }
        updateTitle(calendar.currentData.viewTitle);
      });
    }
  }
  //#region Activity
  activityObj: any = [];
  activityObjTemp: any = [];
  cloneActivityObj: any = [];
  durationDay: any = [];
  durationHour: any = [];
  durationMinute: any = [];
  note: string;
  activityCheckBegDate: string;
  activityCheckDuration: number;
  activitySaveType: string;
  chkActivityOpe: number;
  checkEvent: boolean;
  crossData: any = [];
  searchActAssigner: string;
  timeConvention: number = 0;
  times = [{ id: '', name: 'Choose', ope: 1 }, { id: '8:00 AM', name: '8:00 AM', ope: 1 }, { id: '8:15 AM', name: '8:15 AM', ope: 1 }, { id: '8:30 AM', name: '8:30 AM', ope: 1 }, { id: '8:45 AM', name: '8:45 AM', ope: 1 },
  { id: '9:00 AM', name: '9:00 AM', ope: 1 }, { id: '9:15 AM', name: '9:15 AM', ope: 1 }, { id: '9:30 AM', name: '9:30 AM', ope: 1 }, { id: '9:45 AM', name: '9:45 AM', ope: 1 },
  { id: '10:00 AM', name: '10:00 AM', ope: 1 }, { id: '10:15 AM', name: '10:15 AM', ope: 1 }, { id: '10:30 AM', name: '10:30 AM', ope: 1 }, { id: '10:45 AM', name: '10:45 AM', ope: 1 },
  { id: '11:00 AM', name: '11:00 AM', ope: 1 }, { id: '11:15 AM', name: '11:15 AM', ope: 1 }, { id: '11:30 AM', name: '11:30 AM', ope: 1 }, { id: '11:45 AM', name: '11:45 AM', ope: 1 },
  { id: '12:00 PM', name: '12:00 PM', ope: 1 }, { id: '12:15 PM', name: '12:15 PM', ope: 1 }, { id: '12:30 PM', name: '12:30 PM', ope: 1 }, { id: '12:45 PM', name: '12:45 PM', ope: 1 },
  { id: '1:00 PM', name: '1:00 PM', ope: 1 }, { id: '1:15 PM', name: '1:15 PM', ope: 1 }, { id: '1:30 PM', name: '1:30 PM', ope: 1 }, { id: '1:45 PM', name: '1:45 PM', ope: 1 },
  { id: '2:00 PM', name: '2:00 PM', ope: 1 }, { id: '2:15 PM', name: '2:15 PM', ope: 1 }, { id: '2:30 PM', name: '2:30 PM', ope: 1 }, { id: '2:45 PM', name: '2:45 PM', ope: 1 },
  { id: '3:00 PM', name: '3:00 PM', ope: 1 }, { id: '3:15 PM', name: '3:15 PM', ope: 1 }, { id: '3:30 PM', name: '3:30 PM', ope: 1 }, { id: '3:45 PM', name: '3:45 PM', ope: 1 },
  { id: '4:00 PM', name: '4:00 PM', ope: 1 }, { id: '4:15 PM', name: '4:15 PM', ope: 1 }, { id: '4:30 PM', name: '4:30 PM', ope: 1 }, { id: '4:45 PM', name: '4:45 PM', ope: 1 },
  { id: '5:00 PM', name: '5:00 PM', ope: 1 }, { id: '5:15 PM', name: '5:15 PM', ope: 1 }, { id: '5:30 PM', name: '5:30 PM', ope: 1 }, { id: '5:45 PM', name: '5:45 PM', ope: 1 },
  { id: '6:00 PM', name: '6:00 PM', ope: 1 }, { id: '6:15 PM', name: '6:15 PM', ope: 1 }, { id: '6:30 PM', name: '6:30 PM', ope: 1 }, { id: '6:45 PM', name: '6:45 PM', ope: 1 },
  { id: '7:00 PM', name: '7:00 PM', ope: 1 }, { id: '7:15 PM', name: '7:15 PM', ope: 1 }, { id: '7:30 PM', name: '7:30 PM', ope: 1 }, { id: '7:45 PM', name: '7:45 PM', ope: 1 },
  { id: '8:00 PM', name: '8:00 PM', ope: 1 }
  ];
  endTimes: any = JSON.parse(JSON.stringify(this.times));
  startTimes: any = JSON.parse(JSON.stringify(this.times));
  reminderTimes = [{ id: '0', name: 'Choose' }, { id: '15mins', name: '15m before' }, { id: '30mins', name: '30m before' }, { id: '1hour', name: '1h before' }, { id: '1day', name: '1d before' }]
  durationDay_: any = [];

  bindDurationDay_() {
      for (var i = 0; i < 21; i++) {
        this.durationDay_.push({ id: i, name: i + (i <= 1 ? ' day' : ' days') })
      }
  }

  bindDuration() {
    this.durationDay = [];
    this.durationDay_ = [];
    this.durationHour = [
      { id: 0, name: 0 + ' h' }, { id: 0.5, name: 0.5 + ' h' },
      { id: 1, name: 1 + ' h' }, { id: 1.5, name: 1.5 + ' h' },
      { id: 2, name: 2 + ' h' }, { id: 2.5, name: 2.5 + ' h' },
      { id: 3, name: 3 + ' h' }, { id: 3.5, name: 3.5 + ' h' },
      { id: 4, name: 4 + ' h' }, { id: 4.5, name: 4.5 + ' h' },
      { id: 5, name: 5 + ' h' }, { id: 5.5, name: 5.5 + ' h' },
      { id: 6, name: 6 + ' h' }, { id: 6.5, name: 6.5 + ' h' },
      { id: 7, name: 7 + ' h' }, { id: 7.5, name: 7.5 + ' h' },
      { id: 8, name: 8 + ' h' }, { id: 8.5, name: 8.5 + ' h' },
      { id: 9, name: 9 + ' h' }, { id: 9.5, name: 9.5 + ' h' },
      { id: 10, name: 10 + ' h' }, { id: 10.5, name: 10.5 + ' h' },
      { id: 11, name: 11 + ' h' }, { id: 11.5, name: 11.5 + ' h' },
      { id: 12, name: 12 + ' h' }
    ];
    if (!this.activityObj.showTimeOpe) {
      for (var i = 1; i < 21; i++) {
        this.durationDay.push({ id: i, name: i + (i <= 1 ? ' day' : ' days') })
      }
    }
    else {
      for (var i = 0; i < 21; i++) {
        this.durationDay.push({ id: i, name: i + (i <= 1 ? ' day' : ' days') })
      }
    }
  }
 




  activityModalHeader: string = '';
  projectType: number = 0;
  editActivity(id, projectType) {
    this.projectType = projectType
    $("#eventDetails").modal('hide');
    this.activityModalHeader = 'Edit activity';
    if (projectType == 1) {
      this.editLeadActivity(id);
    }
    else {
      this.editProjectActivity(id);
    }
  }

  editProjectActivity(id) {
    this.reqRes.getData('/Project/GetScheduleActivityPopupData/' + id + '/' + id + '/0').subscribe(data => {
      this.activityObj = data;
      this.activityObj.showTimeOpe = !data.showTimeOpe
      if (id == 0) {
        this.activityModalHeader = 'Create new';
        this.activityObj.begDate = '';
        this.activityObj.durationHour = 0;
        this.activityObj.durationMinute = 0;
        this.activityObj.begTime = '';
       // this.times.push({ id: data.begTime, name: data.begTime, ope: 1 })
        $('#activity').val(this.activityObj.activityTypeId).trigger('change');
      }
      else {
        this.activityModalHeader = 'Edit activity';
        this.changeTimmeAllDayFunc()
        //this.changeTimmeAllDay();
      }
      
      const constCloneActivityObj = JSON.parse(JSON.stringify(this.activityObj));
      this.cloneActivityObj = constCloneActivityObj;
      const cloneOfObject = JSON.parse(JSON.stringify(this.activityObj));
      this.activityObjTemp = cloneOfObject;
      $("#modal_activity").modal('show');
    },
      error => { console.log(error); })
  }




  editLeadActivity(id) {
    this.reqRes.getData('/Lead/GetActivityDetail/' + id).subscribe(data => {
      this.activityObj = data;
      this.activityObj.showTimeOpe = !data.showTimeOpe
      this.bindDuration();
      this.bindDurationDay_();
      if (id == 0) {
        this.activityModalHeader = 'Create new';
        //this.activityObj.begDate = '';
        this.activityObj.durationHour = 0;
        this.activityObj.durationMinute = 0;
       // this.activityObj.begTime = '';
        this.startTimes = JSON.parse(JSON.stringify(this.times));
        this.startTimes.push({ id: data.begTime, name: data.begTime, ope: 1 })
        this.startTimes = this.startTimes.filter((v, i, a) => a.findIndex(v2 => (v2.id === v.id)) === i)
        $('#activity').val(this.activityObj.activityTypeId).trigger('change');
      }
      else {
        this.activityModalHeader = 'Edit activity';
        this.startTimes = JSON.parse(JSON.stringify(this.times));
        this.startTimes.push({ id: data.begTime, name: data.begTime, ope: 1 })
        this.startTimes = this.startTimes.filter((v, i, a) => a.findIndex(v2 => (v2.id === v.id)) === i)

        this.endTimes = JSON.parse(JSON.stringify(this.times));
        this.endTimes.push({ id: data.endTime, name: data.endTime, ope: 1 })
        this.endTimes = this.endTimes.filter((v, i, a) => a.findIndex(v2 => (v2.id === v.id)) === i)
        this.changeTimmeAllDayFunc();
       // this.changeTimmeAllDay();
      }
      const constCloneActivityObj = JSON.parse(JSON.stringify(this.activityObj));
      this.cloneActivityObj = constCloneActivityObj;
      const cloneOfObject = JSON.parse(JSON.stringify(this.activityObj));
      this.activityObjTemp = cloneOfObject;
      $("#modal_activity").modal('show');
      $("body").css("overflow", "hidden");
    },
      error => {
        toastr.error("​Oops! Something went wrong", '', { timeOut: 1000 });
        console.log(error)
      })
  }


  progressing: boolean = false;
  saveActivity() {
    this.progressing = true;
    let filter = ' ';
    let filteredProperties_ = localStorage.getItem('FilterCalendarProperties');
    filter = (this.projectFilteredBgOpe == 0) ? (filteredProperties_) ? filteredProperties_ : ' ' : this.filteredProperties;
    $('#saveModalActivity').attr('disabled', 'disabled');
    this.activityObj.actionType = 'calendar';
    this.activityObj.filter = filter;

    if (this.activityObj.showTimeOpe) {
      this.activityObj.begTime = '9:00 AM';
      this.activityObj.endTime = '9:00 AM';
      let begDate_ = moment(this.activityObj.begDate);
      let endDate_ = moment(this.activityObj.endDate);
      if (this.activityObj.begDate) {
        this.activityObj.durationDay = endDate_.diff(begDate_, "days") + 1;
      }
      else {
        this.activityObj.durationDay = 0;
      }
      this.activityObj.durationHour = 0;
      this.activityObj.durationMinute = 0;
    }
    else {
      let begDate_ = moment(this.activityObj.begDate + ' ' + this.activityObj.begTime, "YYYY-MM-DD h:mm A");
      let endDate_ = moment(this.activityObj.endDate + ' ' + this.activityObj.endTime, "YYYY-MM-DD h:mm A");
      this.activityObj.durationDay = endDate_.diff(begDate_, "days");
      this.activityObj.durationHour = (endDate_.diff(begDate_, "hours") % 24) + ((endDate_.diff(begDate_, "minutes") % 60) / 60)
      this.activityObj.durationMinute = (endDate_.diff(begDate_, "minutes") % 60);
    }
    this.activityObj.activityTypeId = parseInt(this.activityObj.activityTypeId);
    $("body").css("overflow", "auto");
    
    //this.activityObj.showTimeOpe = !this.activityObj.showTimeOpe;
   

    if (this.projectType == 2) {
      if (this.activityObj.relationOpe) {
        this.activityObj.relationOpe = 1;
      }
      else {
        this.activityObj.relationOpe = 0;
      }
      this.activityObj.assignerType = parseInt(this.activityObj.assignerType);
      this.reqRes.postData('/Project/ScheduleActivityPopupSave', this.activityObj).subscribe(result => {
        $("#modal_activity").modal('hide');
        setTimeout(function () {
          $('#saveModalActivity').removeAttr('disabled');
        }, 1000)
        const cloneOfObject = JSON.parse(JSON.stringify(this.activityObj));
        this.activityObjTemp = cloneOfObject;

        this.getCalendarData();
        toastr.success('Done!', '', { timeOut: 1000 });
        this.progressing = false;
        $("body").css("overflow", "auto");
      }
        , error => {
          toastr.error("​Oops! Something went wrong", '', { timeOut: 1000 });
          this.progressing = false;
          console.log(error)
        })
    }
    else {
      this.reqRes.postData('/Lead/LeadActivityOperation', this.activityObj).subscribe(result => {
        $("#modal_activity").modal('hide');
        setTimeout(function () {
          $('#saveModalActivity').removeAttr('disabled');
        }, 1000)
        const cloneOfObject = JSON.parse(JSON.stringify(this.activityObj));
        this.activityObjTemp = cloneOfObject;
        if (this.activityObj.id == 0 && result.length > 0) {
          this.calendarData.push(result[0])
        }
        else {
          let index = this.calendarData.findIndex(item => item.id == this.activityObj.id);
          this.calendarData[index] = result[0];
        }
        this.setCalendar(this.calendarData);
        toastr.success('Done!', '', { timeOut: 1000 });
        this.progressing = false;
        $("body").css("overflow", "auto");
      }, error => {
        toastr.error("​Oops! Something went wrong", '', { timeOut: 1000 });
        this.progressing = false;
        console.log(error)
      })
    }
  }
  modalActivityClose() {
    let result = this.pluginservice.compareObjects(this.activityObj, this.activityObjTemp, ["id", "leadId", "createDate", "createdBy", "createdByName"])
    if (result) {
      if (confirm('Close without saving??')) {
        $("body").css("overflow", "auto");
        $('#modal_activity').modal('hide');
      }
    }
    else {
      $("body").css("overflow", "auto");
      $('#modal_activity').modal('hide');
    }
  }

  activityDateChange(date): void {
    if (!date) {
      this.activityObj.begTime = '';
    }
  }
  changeDurationByActivityTypeId(activityTypeId) {
    this.activityObj.activityTypeList.forEach((val, index) => {
      if (val.id == activityTypeId) {
        if (!this.activityObj.showTimeOpe) {
          if (val.defaultDurationDay == 0) {
            this.activityObj.durationDay = 0;
          }
          else {
            this.activityObj.durationDay = val.defaultDurationDay;
          }
          let _index = this.durationDay.findIndex(item => item.id == 0);
          this.durationDay.splice(_index, 1)
        }
        else {
          if (this.durationDay.filter(e => e.id === 0).length == 0) {
            this.durationDay.unshift({ id: 0, name: 0 + ' h' })
          }
        }
        this.activityObj.durationHour = val.defaultDurationHour;
        this.activityObj.durationMinute = val.defaultDurationMinute;
      }
    });
  }
  activityTypeChange(activityTypeId) {
    this.changeDurationByActivityTypeId(activityTypeId);
    const constCloneActivityObj = JSON.parse(JSON.stringify(this.activityObj));
    this.cloneActivityObj = constCloneActivityObj;
    this.chanheBegDate();
    this.changeBegTime();
  }
  activityAssignerChange(index, obj, ope) {
    if (ope == "add") {
      this.activityObj.assigner.push(obj);
      let _index = this.activityObj.assignerList.findIndex(item => item.id == obj.id);
      this.activityObj.assignerList.splice(_index, 1);
    }
    else if (ope == "remove") {
      this.activityObj.assignerList.push(obj);
      this.activityObj.assigner.splice(index, 1);
      $("[data-toggle='tooltip']").tooltip('hide');
    }
    this.searchActAssigner = '';
  }


  activityAssignerChange_(index, obj, ope, type) {
    if (ope == "add") {
      this.activityObj.assigner.push(obj);
      if (type == 1) {
        let _index = this.activityObj.assignerList.findIndex(item => item.id == obj.id);
        this.activityObj.assignerList.splice(_index, 1);
      }
      else if (type == 2) {
        //let _index = this.activityObj.tradePartnerList.findIndex(item => item.id == obj.id);
        this.activityObj.tradePartnerList.splice(index, 1);
        this.resetSearch();
      }
    }
    else if (ope == "remove") {
      if (type == 1) {
        this.activityObj.assignerList.push(obj);
      }
      else if (type == 2) {
        this.activityObj.tradePartnerList.push(obj);
        this.searchActTradePartner = '';
        this.searchTradepartner();
      }
      this.activityObj.assigner.splice(index, 1);
      $("[data-toggle='tooltip']").tooltip('hide');
    }
    this.searchActAssigner = '';
    this.searchActTradePartner = '';
  }
  resetSearch() {
    this.searchActTradePartner = '';
    this.activityObj.tradePartnerList = [];
  }




  assignerTypeChange() {
    let type = this.activityObj.assignerType;
    this.activityObj.assigner.forEach((v, i) => {
      if (type == 1) {
        this.activityObj.tradePartnerList = [];
      }
      else if (type == 2) {
        this.activityObj.assignerList.push(v);
      }
    })
    if (type == 1) {
      this.searchActTradePartner = '';
      this.searchTradepartner();
    }
    this.activityObj.assigner = [];
  }

  searchActTradePartner: string = "";
  searchTradepartner() {
    if (this.searchActTradePartner.length > 1) {
      let obj: any = {};
      let _ids = [];
      this.activityObj.assigner.forEach((va, ia) => {
        _ids.push(va.id)
      });
      if (_ids.length == 0) { _ids.push(0) }
      obj.ids = _ids.toString();
      obj.searchText = this.searchActTradePartner;
      if (this.activityObj.assignerType == 2) {
        this.reqRes.postData('/Project/GetSearchTradePartner', obj).subscribe(data => {
          this.activityObj.tradePartnerList = data;
        },
          error => {
            toastr.error("​Oops! Something went wrong", '', { timeOut: 1000 });
            console.log(error);
          })
      }
    }
    else {
      this.activityObj.tradePartnerList = [];
    }
  }





  goToLead(id,type) {
    $("#eventDetails").modal('hide');
    if (type == 1) {
      this.router.navigate(['/requestdetail/' + id + '/Overview']);
    }
    else {
      this.router.navigate(['/jobdetail/' + id + '/Overview']);
    }
  }

  //New Activity
  newActivityObj: any = {};
  searchNewActAssigner: string = "";
  addNewActivityTypeModal() {
    this.bindDuration();
    this.bindDurationDay_();
    this.reqRes.getData('/Settings/GetSettingsEditData/0/leadActivityType').subscribe(data => {
      this.newActivityObj = data;
      $("body").css("overflow", "auto");
      $('#modal_activity').modal('hide');
      $('#modal_new_activity').modal('show');
    },
      error => {
        toastr.error("​Oops! Something went wrong", '', { timeOut: 1000 });
        console.log(error);
      })
  }
  activityNewAssignerChange(index, obj, ope) {
    if (ope == "add") {
      this.newActivityObj.assigner.push(obj);
      let _index = this.newActivityObj.assignerList.findIndex(item => item.id == obj.id);
      this.newActivityObj.assignerList.splice(_index, 1);
    }
    else if (ope == "remove") {
      this.newActivityObj.assignerList.push(obj);
      this.newActivityObj.assigner.splice(index, 1);
      $("[data-toggle='tooltip']").tooltip('hide');
    }
    this.searchNewActAssigner = '';
  }
  modalNewActivityClose() {
    $('#modal_activity').modal('show');
    $('#modal_new_activity').modal('hide');
  }
  saveNewActivity() {
    this.newActivityObj.typeId = 1;
    $('#btnNewActivity').attr('disabled', 'disabled');
    this.reqRes.postData('/Settings/ActivityOperation', this.newActivityObj).subscribe(data => {
      $('#btnNewActivity').removeAttr('disabled');
      let returnedObj = data;
      this.activityObj.activityTypeId = returnedObj.id;
      this.activityObj.activityTypeList.push(returnedObj)
      this.activityTypeChange(returnedObj.id)
      toastr.success('Done!', '', { timeOut: 1000 });
      this.modalNewActivityClose();
    },
      error => {
        toastr.error("​Oops! Something went wrong", '', { timeOut: 1000 });
        console.log(error);
      })
  }
   //New Activity END
  //#endregion
  //================================================================================//


  setToday() {
    this.activityObj.begDate = this.activityObj.currentDate;
    this.chanheBegDate();
  }
  addTimeOpe() {
    if (this.activityObj.showTimeOpe) {
      this.activityObj.showTimeOpe = false;
      this.activityObj.begTime = '9:00 AM';
      this.activityObj.durationHour = 0;
      if (this.activityObj.durationDay == 0) {
        this.activityObj.durationDay = 1;
      }
      let _index = this.durationDay.findIndex(item => item.id == 0);
      this.durationDay.splice(_index, 1)
    }
    else {
      if (this.durationDay.filter(e => e.id === 0).length == 0) {
        this.durationDay.unshift({ id: 0, name: 0 + ' h' })
      }
      this.activityObj.showTimeOpe = true;
      this.activityObj.begTime = '';
      this.activityObj.activityTypeList.forEach((val, index) => {
        if (val.id == this.activityObj.activityTypeId) {
          this.activityObj.durationDay = val.defaultDurationDay;
          this.activityObj.durationHour = val.defaultDurationHour;
          this.activityObj.durationMinute = val.defaultDurationMinute;
        }
      });
    }
  }
  statusObj: any = {};

  changeStatusManual(param, id, status, color, name) {
    let statusObj: any = {};
    statusObj.param = param;
    statusObj.id = id;
    statusObj.status = status;
    this.reqRes.postData('/Project/ProjecActivityStatus', statusObj).subscribe(result => {
      let index_ = this.calendarData.findIndex(item => item.id == id);
      this.calendarData[index_].className = 'bg-soft-' + color;
      this.calendarData[index_].status = status;
      this.calendarEventData.statusColor = color;
      this.calendarEventData.statusName = name;
      this.calendarEventData.statusId = status;

      this.setCalendar(this.calendarData);
      toastr.success('Done!', '', { timeOut: 1000 });
    }, error => {
      toastr.error("​Oops! Something went wrong", '', { timeOut: 1000 });
      console.log(error)
    })
  }



  changeStatus(param, id, status, param2): void {
    let statusObj: any = {};
    statusObj.id = id;
    statusObj.param = param;
    statusObj.status = status;
    this.reqRes.postData('/Global/ChangeStatus', statusObj).subscribe(data => {
      let index = this.calendarData.findIndex(item => item.id == id);
      if (param == 'activityStatus') {
        if (status == -1) {
          this.calendarData.splice(index, 1);
        }
        toastr.success('Done!', '', { timeOut: 1000 });
        this.setCalendar(this.calendarData);
      }
      else if (param == "filterStatus") {
        let index = this.filterModalData.filterObj.findIndex(item => item.id == id);
        let DefaultData = this.filterModalData.filterObj.findIndex(item => item.id == id && item.isDefault == 1)
        this.filterModalData.filterObj.splice(index, 1);
        if (this.defaultFiter == id) {
          this.resetFilterSelect();
        }
        if (DefaultData.length > 0) {
          this.projectFilteredBgOpe = 0;
        }
        if (this.filterModalData?.filterObj?.length > 0) {
          $(".savedFiltersArea").removeClass("d-none");
        }
        else {
          $(".savedFilters").css("min-height", "0px");
          $(".savedFiltersArea").addClass("d-none");
        }
        $('#modalProjectFilter').modal('show');
        $('#modalDeleteFilter').modal('hide');
      }
    }, error => {
      toastr.error("​Oops! Something went wrong", '', { timeOut: 1000 });
      console.log(error)
    })
  }

  modalDelete(delId, delType, delType2, bulkArray) {
    this.delId = delId;
    this.delType = delType;
    this.delType2 = delType2;
    this.delBulkArray = bulkArray;
    this.delCount = 1;
    if (delType == 'filterStatus') {
      $('#modalDeleteFilter').modal('show');
      $('#modalProjectFilter').modal('hide');
    }
    else {
      $("#eventDetails").modal('hide');
      $('#modalDelete').modal('show');
    }
  }
  deleteEvent(id) {
      this.reqRes.getData('/Project/ActivityDelete/' + id).subscribe(data => {
        $('#modalDelete').modal('hide');
        let index = this.calendarData.findIndex(item => item.id == id);
        this.calendarData.splice(index, 1);
      this.setCalendar(this.calendarData);
      toastr.success('Done!', '', { timeOut: 1000 });
    }, error => {
      toastr.error("​Oops! Something went wrong", '', { timeOut: 1000 });
      console.log(error);
    })
  }
  deleteItem(id, type, type2, array) {
    this.deleteEvent(id)
  }

  modalDeleteClose() {
    $('#eventDetails').modal('show');
    $('#modalDelete').modal('hide');
  }
  modalDeleteFilterClose() {
    $('#modalProjectFilter').modal('show');
    $('#modalDeleteFilter').modal('hide');
  }
  //#endregion Lead Search Modal




  //#region Filter Project
  //filter variable

  filterModalData: any = [];
  filteredData: any = [];

  filteredDataType: any = [];
  filteredDataActivities: any = [];
  filteredDataAssignee: any = [];
  filteredDataStatuses: any=[];

  projectFilteredBgOpe: number = 0;
  filteredProperties: string;
  projectSelectedFilterData: any = {};
  selectedFilterData_: any = {};
  projectFilterSavedModalData: any = {};
  fid: number = 0;
  defaultFiter: number;
  defaultFilterItem: any;
  allFilterItems: any
  savedFilterId: number = 0;
  FilterName: string = "";
  FilterName_: string = "";
  localstorageVal: string = '';


  getFilterModalData_(type) {
    this.loading = true;
    this.reqRes.getData('/Lead/GetFilterModalData/' + type).subscribe(data => {
      this.filterModalData = data;
      this.allFilterItems = this.filterModalData.filterObj;
      this.defaultFilterItem = this.allFilterItems?.find(item => item.isDefault == 1);
      if (this.defaultFilterItem) {
        this.FilterName = this.defaultFilterItem.name;
      }
      this.projectFilteredBgOpe = (this.defaultFilterItem) ? 1 : 0;
      this.defaultFiter = (this.defaultFilterItem) ? this.defaultFilterItem.id : 0;

      this.filteredProperties = (this.defaultFilterItem) ? JSON.stringify(Object.assign({}, JSON.parse(this.defaultFilterItem.filters))[0]) : '';
      this.fid = (this.defaultFiter != 0) ? this.defaultFiter : 0;
     this.getCalendarData();
    },
      error => {
        toastr.error("​Oops! Something went wrong", '', { timeOut: 1000 });
        console.log(error)
      })
  }

  getFilterModalData(type) {
    this.reqRes.getData('/Lead/GetFilterModalData/' + type).subscribe(data => {
      this.filterModalData = data;
      if (this.projectFilteredBgOpe == 1) {
        this.filteredDataStatuses = (JSON.parse(this.filteredProperties).Statuses) ? JSON.parse(this.filteredProperties).Statuses.split(',').map(i => +i) : '';
        this.filteredDataType = (JSON.parse(this.filteredProperties).Types) ? JSON.parse(this.filteredProperties).Types.split(',').map(i => +i) : '';
        this.filteredDataAssignee = (JSON.parse(this.filteredProperties).Assignee) ? JSON.parse(this.filteredProperties).Assignee.split(',').map(i => +i) : '';
        this.filteredDataActivities = (JSON.parse(this.filteredProperties).Activities) ? JSON.parse(this.filteredProperties).Activities.split(',').map(i => +i) : '';


        if (this.defaultFiter != 0) {
          this.fid = this.defaultFiter;
          this.filterModalData.filterObj.forEach((value) => {
            if (value.id == this.defaultFiter) {
              value.ope = 1;
            }
          })
        }
      }
      else {
        let defTypeItems = [];
        this.filterModalData.typeObj.forEach((v,i) => {
          defTypeItems.push(v.id);
        })
        this.filteredDataStatuses = [];
        this.filteredDataType = defTypeItems;
        this.filteredDataActivities = [];
        this.filteredDataAssignee = [];
        this.fid = 0;
      }
    },
      error => {
        toastr.error("​Oops! Something went wrong", '', { timeOut: 1000 });
        console.log(error)
      })
  }
  filterOption(type) {
    this.getFilterModalData(type);
    $('#modalProjectFilter').modal('show');
    if (this.filterModalData?.filterObj?.length > 0) {
      $(".savedFiltersArea").removeClass("d-none");
    }
    else {
      $(".savedFilters").css("min-height", "0px");
      $(".savedFiltersArea").addClass("d-none");
    }
  }
  selecChange() {
    this.fid = 0;
    this.filterModalData.filterObj.map((item) => item.isDefault = 0);
    this.filterModalData.filterObj.map((item) => item.ope = 0)
  }


  newFilterModalHeader: string = '';
  editProjectFilterName(id) {
    this.savedFilterId = id;
    this.newFilterModalHeader = (id == 0) ? this.newFilterModalHeader = 'New Filter' : 'Rename Filter';

    this.reqRes.getData('/Lead/GetFilterSavedModalData/' + id + "/Calendar").subscribe(data => {
      this.projectFilterSavedModalData = data[0];
    },
      error => {
        toastr.error("​Oops! Something went wrong", '', { timeOut: 1000 });
        console.log(error)
      })
    $("#modalProjectFilter").modal("hide");
    $("#saveProjectFilter").modal("show");
  }

  closeModalProjectFilter() {
    $("#saveProjectFilter").modal("hide");
    $("#modalProjectFilter").modal("show");
  }

  saveProjectFilter() {
    $("[data-toggle='tooltip']").tooltip('hide');
    let arrayCollectData = [{
      "Statuses": this.filteredDataStatuses.toString(),
      "Types": this.filteredDataType.toString(),
      "Assignee": this.filteredDataAssignee.toString(),
      "Activities": this.filteredDataActivities.toString(),
    }];
    this.selectedFilterData_["filters"] = JSON.stringify(arrayCollectData);
    this.selectedFilterData_["name"] = this.projectFilterSavedModalData.name;
    this.selectedFilterData_["type"] = 'Calendar';
    this.selectedFilterData_["id"] = this.projectFilterSavedModalData.id;
    this.reqRes.postData('/Lead/LeadFilterOperation', this.selectedFilterData_).subscribe(data => {
      this.closeModalProjectFilter();
      if (this.savedFilterId == 0) {
        this.filterModalData.filterObj[this.filterModalData.filterObj.length] = data[0];
      } else {
        this.filterModalData.filterObj.find(item => item.id == this.savedFilterId).name = data[0].name
      }

      toastr.success('Done!', '', { timeOut: 1000 });
    }, error => {
      toastr.error("​Oops! Something went wrong", '', { timeOut: 1000 });
      console.log(error)
    })
  }
  setClickedLast(fid) {
    this.filterModalData.filterObj.map((item) => item.isDefault = 0);
    this.filterModalData.filterObj.filter((item) => item.id == fid)[0].isDefault = 1;
    this.filterModalData.filterObj.forEach((val, key) => {
      if (fid == val.id) {
        if (val.ope == false) {
          val.ope = true;
        }
        else {
          val.ope = false;
        }
      }
      else {
        val.ope = false;
      }
    });
  }

  showSavedFiltersDetails(f) {
    this.setClickedLast(f.id);
    this.FilterName_ = f.name;

    let filters = JSON.parse(this.filterModalData.filterObj.find(item => item.id == f.id).filters);
    this.filteredDataStatuses = (filters[0].Statuses) ? filters[0].Statuses.split(',').map(x => +x) : '';
    this.filteredDataType = (filters[0].Types) ? filters[0].Types.split(',').map(x => +x) : '';
    this.filteredDataActivities = (filters[0].Activities) ? filters[0].Activities.split(',').map(x => +x) : '';
    this.filteredDataAssignee = (filters[0].Assignee) ? filters[0].Assignee.split(',').map(x => +x) : '';
    this.defaultFiter = f.id;
    this.fid = f.id

    if (this.filterModalData.filterObj.every(val => val.ope == false)) {
      //reset selectpicker
      this.filteredDataStatuses = [];
      let defTypeItems = [];
      this.filterModalData.typeObj.forEach((v, i) => {
        defTypeItems.push(v.id);
      })
      this.filteredDataType = defTypeItems;
      this.filteredDataActivities = [];
      this.filteredDataAssignee = [];
      this.fid = 0;
    }
  }

  getProjectFilterResult() {
    $("[data-toggle='tooltip']").tooltip('hide');
    this.projectSelectedFilterData["Statuses"] = (this.filteredDataStatuses) ? this.filteredDataStatuses.toString() : '';
    this.projectSelectedFilterData["Activities"] = (this.filteredDataActivities) ? this.filteredDataActivities.toString() : '';
    this.projectSelectedFilterData["Types"] = (this.filteredDataType) ? this.filteredDataType.toString() : '';
    this.projectSelectedFilterData["Assignee"] = (this.filteredDataAssignee) ? this.filteredDataAssignee.toString() : '';
   
    this.filteredProperties = JSON.stringify(this.projectSelectedFilterData);

    this.FilterName = this.FilterName_;
    if (this.filteredDataStatuses.length != 0 || this.filteredDataActivities.length != 0 || this.filteredDataAssignee.length != 0 || this.filteredDataType.length != 0) {
      this.projectFilteredBgOpe = 1
    } else {
      this.projectFilteredBgOpe = 0
      this.fid = 0;
    }
    this.defaultFiter = (this.fid != 0) ? this.fid : 0;

    this.changeStatus('changeFilterLastCalendar', this.defaultFiter, 1, '');

    if (this.defaultFiter == 0) {
      localStorage.setItem('FilterCalendarProperties', this.filteredProperties);
    } else {
      localStorage.removeItem('FilterCalendarProperties');
    }

    if (this.filteredDataStatuses.length == 0 && this.filteredDataActivities.length == 0 && this.filteredDataAssignee.length == 0 && this.filteredDataType.length == 0) {
      localStorage.removeItem('FilterCalendarProperties');
    }
    this.localstorageVal = (localStorage.getItem('FilterCalendarProperties')) ? localStorage.getItem('FilterCalendarProperties') : '';
    this.getCalendarData();

    $("div[id^=threeNo] button").prop('disabled', false);
    $('#modalProjectFilter').modal('hide');
  }

  resetFilterSelect() {
    this.filteredDataStatuses = [];
    let defTypeItems = [];
    this.filterModalData.typeObj.forEach((v, i) => {
      defTypeItems.push(v.id);
    })
    this.filteredDataType = defTypeItems;
    this.filteredDataActivities = [];
    this.filteredDataAssignee = [];
    this.projectFilteredBgOpe = 0;
    this.fid = 0;
    this.filteredProperties = '';
    this.defaultFiter = 0;
    $("div[id^=threeNo] button").prop('disabled', false);
    localStorage.removeItem('FilterCalendarProperties');
    this.localstorageVal = (localStorage.getItem('FilterCalendarProperties')) ? localStorage.getItem('FilterCalendarProperties') : '';
    this.getCalendarData();
    this.changeStatus('resetFilterOperationCalendar', 0, -1, '');
  }

  changeFilter(f) {
    this.FilterName = f.name
    this.projectFilteredBgOpe = 1
    this.filteredProperties = JSON.stringify(JSON.parse(f.filters)[0]);
    this.defaultFiter = f.id;
    this.changeStatus('changeFilterLastCalendar', this.defaultFiter, 1, '');
    this.getCalendarData();
    localStorage.removeItem('FilterCalendarProperties');
    //localStorage.setItem('FilterCalendarProperties', this.filteredProperties);
    this.localstorageVal = (localStorage.getItem('FilterCalendarProperties')) ? localStorage.getItem('FilterCalendarProperties') : '';
  }

  searchInputOperation() {
    $('.custom-search-input').focus();
    $("[data-toggle='tooltip']").tooltip('hide');
  }
  searchFilterAssigner: string = "";

  filteredDataAssignee_: any = [];
  activityFilteerAssignerChange(index, obj, ope) {
    if (ope == "add") {
      this.filteredDataAssignee_.push(obj);
      this.filteredDataAssignee.push(obj.id);
      let _index = this.filterModalData.assigneeObj.findIndex(item => item.id == obj.id);
      this.filterModalData.assigneeObj.splice(_index, 1);
    }
    else if (ope == "remove") {
      this.filterModalData.assigneeObj.push(obj);
      this.filteredDataAssignee_.splice(index, 1);
      this.filteredDataAssignee.splice(index, 1);
      $("[data-toggle='tooltip']").tooltip('hide');
    }
    this.searchFilterAssigner = '';
  }
  copyStringToClipboard(str) {
    navigator.clipboard.writeText(str);
    toastr.success('Copied succesfully!', '', { timeOut: 1000 });
  }
  //#endregion Filter Project




  setEndTimeMin() {
    this.endTimes.forEach((v, i) => {
      v.ope = 1;
    })
    if (this.activityObj.begDate == this.activityObj.endDate) {
      let begTime_ = new Date(this.activityObj.begDate + ' ' + this.activityObj.begTime);
      this.endTimes.forEach((v, i) => {

        if (new Date(this.activityObj.endDate + ' ' + v.id) < begTime_) {
          v.ope = 0
        }
      })
    }
  }
  changeBegTime() {
    if (!this.activityObj.showTimeOpe) {
      this.activityObj.activityTypeList.forEach((val, index) => {
        if (val.id == this.activityObj.activityTypeId) {
          this.activityObj.durationHour = val.defaultDurationHour;
          this.activityObj.durationMinute = val.defaultDurationMinute;
        }
      });
    }
    else {
      this.activityObj.activityTypeList.forEach((val, index) => {
        if (val.id == this.activityObj.activityTypeId) {
          this.activityObj.durationDay = val.defaultDurationDay;
        }
      });
    }
    //this.changeTimmeAllDay();
    if (!this.activityObj.begTime) {
      this.activityObj.endTime = '';
    }
    if (this.activityObj.begDate && this.activityObj.begTime) {
      let time_ = moment(this.activityObj.begDate + ' ' + this.activityObj.begTime, "YYYY-MM-DD h:mm A");

      if (this.activityObj.durationHour != 0) {
        time_ = moment(time_).add(this.activityObj.durationHour, 'hours');
      }
      else {
        if (this.activityObj.begDate == this.activityObj.endDate) {
          time_ = moment(time_).add(1, 'hours');
        }
        else {
          time_ = moment(time_).add(this.activityObj.durationHour, 'hours');
        }
      }
      this.endTimes.push({ id: moment(time_).format('LT'), name: moment(time_).format('LT'), ope: 1 })
      this.endTimes = this.endTimes.filter((v, i, a) => a.findIndex(v2 => (v2.id === v.id)) === i)
      this.activityObj.endTime = moment(time_).format('h:mm A');
      this.setEndTimeMin();
    }
  }

  chanheBegDate() {
    if (this.activityObj.begDate) {
      if (!this.activityObj.showTimeOpe) {
        this.activityObj.activityTypeList.forEach((val, index) => {
          if (val.id == this.activityObj.activityTypeId) {
            this.activityObj.durationDay = val.defaultDurationDay;
            this.activityObj.durationHour = val.defaultDurationHour;
            this.activityObj.durationMinute = val.defaultDurationMinute;
          }
        });
      }
      else {
        this.activityObj.activityTypeList.forEach((val, index) => {
          if (val.id == this.activityObj.activityTypeId) {
            this.activityObj.durationDay = val.defaultDurationDay;
          }
        });
      }
    }
    if (this.activityObj.begDate) {
      if (this.activityObj.durationDay != 0) {
        this.changeTimmeAllDay();
      }
      else {
        this.activityObj.endDate = this.activityObj.begDate;
      }
      this.setEndTimeMin();
    }
    else {
      this.activityObj.endDate = '';
      this.activityObj.endTime = '';
      this.activityObj.begTime = '';
    }
  }
  changeEndDate() {
    this.setEndTimeMin();
  }
  changeTimmeAllDayFunc() {
    if (this.activityObj.begDate) {
      if (this.activityObj.showTimeOpe) {
        if (this.activityObj.durationDay > 0) {
          this.activityObj.endDate = moment(this.activityObj.begDate).clone().add((this.activityObj.durationDay - 1), 'days').format('YYYY-MM-DD');
        }
        else {
          this.activityObj.endDate = this.activityObj.begDate;
        }
      }
      else {
        if (this.activityObj.durationDay > 0) {
          this.activityObj.endDate = moment(this.activityObj.begDate).clone().add((this.activityObj.durationDay), 'days').format('YYYY-MM-DD');
        }
        else {
          this.activityObj.endDate = this.activityObj.begDate;
        }
      }
    }
    else {
      this.activityObj.endDate = ''
    }
  }
  changeTimmeAllDay() {
    this.changeDurationByActivityTypeId(this.activityObj.activityTypeId);
    this.changeTimmeAllDayFunc();
  }
  changeAllDay() {
    //this.activityObj.begTime = '';
    //this.activityObj.endTime = '';
    this.changeTimmeAllDay();
    this.changeBegTime();
  }


}
